import React from "react";
import { CatalogButton, FocusAreaDropdown, SearchReset, TextSearch} from "./components/Searchers.js";
import ModuleCarousel from "./components/ModuleCarousel.js";
import ModuleCards from "./components/ModuleCards.js";
import "./MainPage.css";
import allTrainings from "../assets/data/training_master.json";
import { Container } from "react-bootstrap";


function MainPage(props) {
    /**
     * Component for the main training page containing listing of training modules. Takes all imported sub-components and creates the full HTML page.
     * @param props: props passed down from the App component (training list, carousel list, event handlers, carousel index, and text query)
     * @returns: main page JSX component with header, carousel, catalog button, searchers, and module cards.
     */

    // Upon main page rendering, set the document title to the following string for display in browser tab
    document.title = `NASA SPoRT Training`;

    // Filter the JSON trainings to the select ones for the carousel, store in variable to pass to ModuleCarousel component
    const carouselTrainings = allTrainings["training"].filter(training => props.carouselList.includes(Object.keys(training)[0]));

    return (
        <div className="bg-image-sport body-sport">
            <br/>

            <Container className="dark-bg1-sport text-center mx-0">
                <h2>NASA SPoRT Training Modules</h2>

                <ModuleCarousel trainings={carouselTrainings} carouselHandler={props.carouselHandler} carouselIndex={props.carouselIndex}/>

                <CatalogButton />
                <FocusAreaDropdown focusArea={props.focusArea} focusAreaHandler={props.focusAreaHandler}/>
                <SearchReset resetTrainings={props.resetTrainings}/>
                <TextSearch query={props.query} queryHandler={props.queryHandler}/>
            </Container>
            
            <br/>
            <ModuleCards trainingList={props.trainingList}/>
        </div>
    );
}

export default MainPage;